<script>
	import { onDestroy } from 'svelte'
	import { getContext } from 'svelte'
	import { styles } from '../../../library/scripts/styles.js'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { get_file_size } from '../../../library/scripts/utils'
	import { storeUploader, storeShowItem, storeRemainingStorage } from '../../../library/scripts/Store.svelte'
	import { upload_image, delete_image } from '../../../library/scripts/fileUploader'
	import { adminUpdateRoomsEntry, SingleItem, check_values, ghRoomNumber } from '../AdminModule.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')

	//the upload action
	let upload
	const stoUploader = storeUploader.subscribe((value) => {
		upload = value
	})

	const shadow = globals.boxShadow
	const fontX = globals.fsL
	const fontM = globals.fsN
	const fontS = globals.fsS
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover
	const color = globals.colorMain
	const inputFocus = globals.bgLight

	$: roomName = 'Room ' + $ghRoomNumber

	//the new element to add
	let addElement = {}

	//values for item entries

	let bedSize = ''
	let guests = 1
	let description = ''
	let image = ''
	let low = ''
	let high = ''
	let bookings = ''
	let currency = 'CHF'
	let breakfast = true

	//update room
	let oldImage = ''

	//store the rooms
	let rooms = []

	//success and error message
	let error = false
	let success = false

	//message to the user
	let message = ''

	//alert window
	let alertError = false

	//create single item entries if item is changed by user
	let singleItem
	const stoSingleItem = SingleItem.subscribe((value) => {
		singleItem = value
	})

	//get room name if its an update
	$: if (singleItem) {
		const amendItem = singleItem.split('~')
		roomName = 'Room ' + amendItem[0]
		bedSize = amendItem[1]
		guests = amendItem[2]
		description = amendItem[3]
		oldImage = amendItem[4]
		low = parseFloat(amendItem[5]).toFixed(2)
		high = parseFloat(amendItem[6]).toFixed(2)
		bookings = amendItem[7]
		currency = amendItem[8]
		breakfast = amendItem[9]
	}

	/*************************** new items **********************************/

	//check for errors
	function check_item(c) {
		let check = false

		//new item
		if (!c) {
			//check if the room already exists
			let duplicate = false

			const sessItems = JSON.parse(sessionStorage.getItem('rooms'))

			sessItems.forEach((item) => {
				for (const key in item) {
					if (item['number'] === roomName) {
						error = true
						message = 'duplicate room'
						duplicate = true
						set_error()
					}
				}
			})
			//if the room exists we return with no action
			if (duplicate) return
		}

		//if it's an update we get the room number
		let roomNumber = $ghRoomNumber
		if (singleItem) {
			const amendItem = singleItem.split('~')
			roomNumber = amendItem[0]
		}

		addElement = {
			number: roomNumber,
			bedSize: bedSize,
			guests: guests,
			description: description,
			image: image,
			low: low,
			high: high,
			bookings: bookings,
			currency: currency,
			breakfast: breakfast,
		}

		//evaluate entries
		check = check_values('rooms', addElement)

		// if all is ok we add the room to the db
		if (check === true) {
			if (!c) save_item(addElement)
			if (c) update_item(addElement)
			return
		}

		error = true
		message = check
		set_error()
	}

	const save_item = async (item) => {
		//shader
		storeUploader.set(true)

		//create the item to store to session store
		let storeItem = { ...item }

		//get session storage
		let sessItems = JSON.parse(sessionStorage.getItem('rooms'))

		//get the name of the image
		const image = item.image.files[0].name
		storeItem.image = image

		//save the item to the db
		const saveItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'save_room',
				data: {
					number: $ghRoomNumber,
					bedSize: item.bedSize,
					description: item.description,
					image: item.image.files[0].name,
					low: item.low,
					high: item.high,
					bookings: item.bookings,
					currency: item.currency,
					guests: item.guests,
					breakfast: item.breakfast,
				},
			}),
		})

		const dataResponse = await saveItem.json()

		//if the item is added to the DB sucessfully we continue saving
		if (dataResponse) {
			//first we check if the image is already used by another item
			let usedImage = false

			sessItems.forEach((item) => {
				for (const key in item) {
					if (item['image'] === image) usedImage = true
				}
			})

			//close the shader if no image is attached
			if (usedImage) storeUploader.set(false)

			//save the image
			if (!usedImage) {
				const uploadImage = upload_image('rooms', item.image, item.number)
				//shader is handled by function
			}
		}

		//safe the item to the session storage
		sessItems = [...sessItems, storeItem]
		sessionStorage.setItem('rooms', JSON.stringify(sessItems))

		//update page
		adminUpdateRoomsEntry.set(JSON.stringify(sessItems))

		//update room number
		ghRoomNumber.set(sessItems.length + 1)
		roomName = 'Room ' + (sessItems.length + 1)

		//reset currency variable
		currency = 'CHF'
	}

	const update_item = async (item) => {
		//the shader
		storeUploader.set(true)
		//create the old image value
		item = { ...item, oldimage: oldImage }

		//item copy to replace image-object with image-name for storing
		let itemStorage = { ...item }
		itemStorage.image = item.image.files[0].name

		//update the db
		const updateItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'update_room',
				data: itemStorage,
			}),
		})

		const response = await updateItem.json()

		if (response.rooms) {
			//close the single item
			SingleItem.set(false)
			storeShowItem.set(false)
			roomName = 'Room ' + $ghRoomNumber
			bedSize = ''
			guests = 1
			description = ''
			low = ''
			high = ''

			//create the room objects
			let updatedRooms = []

			//update store and session-storage
			response.rooms.forEach((item) => {
				updatedRooms.push({
					number: item[0],
					bedSize: item[1],
					guests: item[2],
					description: item[3],
					image: item[4],
					low: parseInt(item[5].toFixed(2)),
					high: parseInt(item[6].toFixed(2)),
					bookings: item[7],
					currency: item[8],
					breakfast: item[9],
				})
			})

			/** image handling **/
			let imageCounter = 0
			let uploadImage = true

			//same image added
			if (itemStorage.image === itemStorage.oldimage) uploadImage = false

			if (itemStorage.image !== itemStorage.oldimage) {
				// check if the image is used by another item
				const sessRooms = JSON.parse(sessionStorage.getItem('rooms'))
				sessRooms.forEach((item) => {
					for (let key in item) {
						if (key === 'image') {
							if (item.number !== itemStorage.number && item.image === itemStorage.image) {
								uploadImage = false
							}
						}
					}
				})

				const upImg = upload_image('rooms', item.image, item.number)

				//close shader is handled by function upload_image

				//check if we have to delete the old image
				sessRooms.forEach((item) => {
					for (let key in item) {
						if (key === 'image') {
							if (item.number !== itemStorage.number && oldImage === item.image) {
								imageCounter++
							}
						}
					}
				})
				if (imageCounter === 0) {
					const delImg = await delete_image('rooms', itemStorage.oldimage)
				}
			}
			if (!uploadImage) storeUploader.set(false)
			sessionStorage.setItem('rooms', JSON.stringify(updatedRooms))
			adminUpdateRoomsEntry.set(JSON.stringify(updatedRooms))
		}

		//get the file-size
		const fileSize = get_file_size()

		fileSize.then((value) => {
			storeRemainingStorage.set(value)
		})
	}

	/***************************** general ************************************/

	const set_error = () => {
		const toError = setTimeout(() => {
			error = false
			message = ''
			clearTimeout(toError)
		}, 2000)
	}

	const close_update = () => {
		roomName = ''
		bedSize = ''
		description = ''
		oldImage = ''
		low = ''
		high = ''
		guests = 1
		SingleItem.set(false)
		singleItem = false
		storeShowItem.set(false)
	}

	//reset error messages
	const reset_error = () => {
		error = false
		success = false
		alertError = false
	}

	onDestroy(() => {
		stoSingleItem
		stoUploader
	})
</script>

<div class="container">
	{#if upload}
		<Shader>
			<div slot="content">
				<Spinner color="hsl(0,0%,60%)" size="4vw" info="content updating" fontsize={fontM} />
			</div>
		</Shader>
	{/if}
	{#if !singleItem}
		<div class="title" use:styles={{ color, fontX }}>CREATE ROOM</div>
		<form use:styles={{ fontS }}>
			<label use:styles={{ fontM, color }} for="item">name</label>

			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="item"
				readonly
				bind:value={roomName}
			/>

			<label use:styles={{ fontM, color }} for="item">beds</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="249"
				placeholder="single/double etc."
				bind:value={bedSize}
			/>

			<label use:styles={{ fontM, color }} for="guests">sleeps</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="number"
				id="guests"
				min="1"
				bind:value={guests}
			/>

			<label use:styles={{ fontM, color }} for="description">description</label>
			<textarea
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="description"
				placeholder="description"
				bind:value={description}
			/>

			<label use:styles={{ fontM, color }} for="image">image</label>
			<input
				use:styles={{ fontM, color, shadow }}
				on:focus={reset_error}
				type="file"
				id="image"
				accept="image/*"
				bind:this={image}
			/>

			<label use:styles={{ fontM, color }} for="size">low season</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="6"
				placeholder="room off-season price"
				bind:value={low}
			/>
			<label use:styles={{ fontM, color }} for="price">high season</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="price"
				maxlength="6"
				placeholder="high-season price"
				bind:value={high}
			/>
			<label use:styles={{ fontM, color }} for="currency">currency</label>
			<select use:styles={{ shadow, fontM, color }} id="currency" bind:value={currency}>
				<option value="CHF">CHF</option>
				<option value="EUR">EUR</option>
				<option value="USD">USD</option>
				<option value="ZAR">ZAR </option>
				<option value="YEN">YEN</option>
			</select>

			<label use:styles={{ fontM, color }} margins for="guests">breakfast</label>
			<input type="checkbox" id="breakfast" bind:checked={breakfast} />

			<button use:styles={{ fontS, shadow, buttonColor, buttonHover }} on:click|preventDefault={() => check_item(false)}
				>save</button
			>

			<!-- error and other messages -->
			{#if error}
				<div class="message error">{message}</div>
			{/if}
			{#if success}
				<div class="message success">{message}</div>
			{/if}
		</form>
	{:else}
		<div class="title" use:styles={{ color, fontX }}>UPDATE</div>
		<form use:styles={{ fontS }}>
			<div class="sub_title" use:styles={{ fontM, color }}>name</div>
			<div class="sub_title" use:styles={{ fontM, color }}>{roomName}</div>
			<div class="sub_title" use:styles={{ fontM, color }}>sleeps</div>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="number"
				id="guests"
				min="1"
				bind:value={guests}
			/>
			<div class="sub_title" use:styles={{ fontM, color }}>beds</div>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="249"
				placeholder="single/double etc."
				bind:value={bedSize}
			/>
			<label use:styles={{ fontM, color }} for="description">description</label>
			<textarea
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="description"
				placeholder="description"
				bind:value={description}
			/>

			<label use:styles={{ fontM, color }} for="image">image</label>
			<input
				use:styles={{ fontM, color, shadow }}
				on:focus={reset_error}
				type="file"
				id="image"
				accept="image/*"
				bind:this={image}
			/>

			<label use:styles={{ fontM, color }} for="size">low season</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="6"
				placeholder="room off-season price"
				bind:value={low}
			/>
			<label use:styles={{ fontM, color }} for="price">high season</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="price"
				maxlength="6"
				placeholder="high-season price"
				bind:value={high}
			/>

			<label use:styles={{ fontM, color }} for="currency">currency</label>
			<select use:styles={{ shadow, fontM, color }} id="currency" bind:value={currency}>
				<option value="CHF">CHF</option>
				<option value="EUR">EUR</option>
				<option value="USD">USD</option>
				<option value="ZAR">ZAR </option>
				<option value="YEN">YEN</option>
			</select>

			<label use:styles={{ fontM, color }} margins for="guests">breakfast</label>
			<input type="checkbox" id="breakfast" bind:checked={breakfast} />

			<div class="button_container">
				<button use:styles={{ fontS, shadow, buttonColor, buttonHover }} on:click|preventDefault={close_update}
					>close</button
				>
				<button
					use:styles={{ fontS, shadow, buttonColor, buttonHover }}
					on:click|preventDefault={() => check_item(true)}>save</button
				>
			</div>

			<!-- error and other messages -->
			{#if error}
				<div class="message error">{message}</div>
			{/if}
			{#if success}
				<div class="message success">{message}</div>
			{/if}
		</form>
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		width: 100%;
		cursor: default;
		user-select: none;
	}

	.title {
		font-size: var(--fontX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 20px;
	}

	form {
		display: grid;
		grid-template-columns: 30% 70%;
		width: 85%;
		margin-left: 3%;
		font-size: var(--fontS);
	}

	label,
	.sub_title {
		display: flex;
		align-items: flex-start;
		font-size: var(--fontM);
		color: var(--color);
	}

	.sub_title {
		margin-bottom: 30px;
	}

	input[type='text'],
	input[type='file'],
	input[type='number'],
	textarea {
		outline: none;
		box-shadow: 3px 3px 3px var(--shadow);
		font-size: var(--fontM);
		border: 1px solid ghostwhite;
		background-color: transparent;
		color: var(--color);
		width: 100%;
	}

	textarea {
		resize: none;
	}

	input[type='text']:focus,
	textarea:focus {
		background-color: var(--inputFocus);
	}

	input[type='checkbox'] {
		margin-top: 15px;
		margin-bottom: 15px;
		width: 25px;
	}

	[margins] {
		margin-top: 15px;
		margin-bottom: 15px;
	}

	select {
		border: 1px solid ghostwhite;
		background-color: transparent;
		box-shadow: 3px 3px 3px var(--shadow);
		color: var(--color);
	}

	option {
		background-color: black;
		color: white;
	}

	.button_container {
		width: 90%;
		display: flex;
		justify-content: flex-end;
		grid-column-start: 1;
		grid-column-end: 3;
	}

	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-left: 5%;
		border-radius: 5px;
		font-size: var(--fontS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.message {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: center;
		font-size: clamp(0.8rem, 1.1vw, 1.2rem);
	}

	.success {
		color: green;
	}

	.error {
		color: red;
	}
</style>
